import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Whether the Statista charts behind the Category & Competition figures render.
 * Off by default, so the section keeps its generated prose alone.
 *
 * Read on both render paths (the live route and the `/download` print page
 * mount under the same app-root OpenFeature provider), so an exported PDF
 * carries the charts whenever the screen does.
 */
export const useIqStatistaChartsEnabled = (): boolean =>
  useBooleanFlagValue('iq_statista_charts', false);
